var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraduationCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1579 9.0188V14.429C18.1579 15.1084 18.1579 15.4482 18.0266 15.741C17.9834 15.8373 17.9302 15.9287 17.8678 16.0138C17.6781 16.2727 17.3828 16.4406 16.7921 16.7763L13.3342 18.7417C12.7565 19.07 12.4677 19.2342 12.1548 19.2666C12.0519 19.2773 11.9481 19.2773 11.8452 19.2666C11.5323 19.2342 11.2435 19.07 10.6658 18.7417L7.20794 16.7763C6.61722 16.4406 6.32187 16.2727 6.13216 16.0138C6.06981 15.9287 6.01661 15.8373 5.97344 15.741C5.84211 15.4482 5.84211 15.1084 5.84211 14.429V9.0188M21 7.64286L13.129 4.01969C12.6361 3.79283 12.3897 3.6794 12.1293 3.65687C12.0432 3.64943 11.9568 3.64943 11.8707 3.65687C11.6103 3.6794 11.3639 3.79283 10.871 4.01969L3 7.64286L10.8235 11.4304C11.3362 11.6786 11.5925 11.8027 11.8649 11.8274C11.9548 11.8355 12.0452 11.8355 12.1351 11.8274C12.4075 11.8027 12.6638 11.6786 13.1765 11.4304L21 7.64286ZM21 7.64286V16.9C21 17.4876 21 17.7814 20.898 18.0437C20.8644 18.1302 20.8228 18.2134 20.7738 18.2922C20.6251 18.5311 20.3901 18.7074 19.92 19.06L18.75 19.9375",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationCap);
export default __webpack_public_path__ + "static/media/graduation-cap.37b70fba64d221bd608c96507f6966f5.svg";
export { ForwardRef as ReactComponent };